import React, { useEffect, useState } from 'react';
import { getApiUrl } from '../config';
import { TAG_EMOJIS } from '../constants/reviewConstants';

interface TagItem {
  tag: string;
  count: number;
  isPositive: boolean;
}

interface TopTagsCardProps {
  userId: string | undefined;
  title?: string;
  isMobile?: boolean;
}

const getTagEmoji = (tagName: string): string => TAG_EMOJIS[tagName] ?? '⭐';

export const TopTagsCard: React.FC<TopTagsCardProps> = ({
  userId,
  title = 'Tu reputación',
  isMobile = false,
}) => {
  const [tags, setTags] = useState<TagItem[]>([]);
  const [loading, setLoading] = useState(!!userId);

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      return;
    }
    const token = localStorage.getItem('authToken');
    if (!token) {
      setLoading(false);
      return;
    }
    setLoading(true);
    fetch(getApiUrl(`/api/reviews/user/${userId}/tags`), {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => (res.ok ? res.json() : Promise.resolve([])))
      .then((data) => {
        const list = Array.isArray(data) ? data : [];
        setTags(list);
      })
      .catch(() => setTags([]))
      .finally(() => setLoading(false));
  }, [userId]);

  const topPositive = tags.filter((t) => t.isPositive)[0] ?? null;
  const topNegative = tags.filter((t) => !t.isPositive)[0] ?? null;

  if (loading) {
    return (
      <div
        style={{
          background: '#23272A',
          padding: isMobile ? 16 : 24,
          borderRadius: 18,
          border: '1px solid #33383B',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 100,
        }}
      >
        <span style={{ color: '#B0BEC5' }}>Cargando...</span>
      </div>
    );
  }

  if (!topPositive && !topNegative) {
    return null;
  }

  return (
    <div
      style={{
        background: '#23272A',
        padding: isMobile ? 16 : 24,
        borderRadius: 18,
        boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
        border: '1px solid #33383B',
      }}
    >
      <h3
        style={{
          fontSize: isMobile ? 16 : 20,
          fontWeight: 700,
          color: '#FFFFFF',
          margin: '0 0 16px 0',
        }}
      >
        {title}
      </h3>
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        {topPositive && (
          <div
            style={{
              flex: 1,
              minWidth: 120,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 16,
              borderRadius: 16,
              border: '2px solid #00E676',
              background: 'rgba(0, 230, 118, 0.08)',
              gap: 4,
            }}
          >
            <span style={{ fontSize: 28 }}>{getTagEmoji(topPositive.tag)}</span>
            <span style={{ fontSize: 14, fontWeight: 600, color: '#FFFFFF', textAlign: 'center' }}>
              {topPositive.tag}
            </span>
            <span style={{ fontSize: 20, fontWeight: 800, color: '#00E676' }}>{topPositive.count}</span>
          </div>
        )}
        {topNegative && (
          <div
            style={{
              flex: 1,
              minWidth: 120,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 16,
              borderRadius: 16,
              border: '2px solid #EF4444',
              background: 'rgba(255, 23, 68, 0.08)',
              gap: 4,
            }}
          >
            <span style={{ fontSize: 28 }}>{getTagEmoji(topNegative.tag)}</span>
            <span style={{ fontSize: 14, fontWeight: 600, color: '#FFFFFF', textAlign: 'center' }}>
              {topNegative.tag}
            </span>
            <span style={{ fontSize: 20, fontWeight: 800, color: '#EF4444' }}>{topNegative.count}</span>
          </div>
        )}
      </div>
    </div>
  );
};
